
/**
 * Load packages
 */

try {
    window.$ = window.jQuery = require('jquery');

    window.Bloodhound = require('corejs-typeahead/dist/bloodhound');
    window.debounce = require('javascript-debounce');
    window.Popper = require('popper.js').default;
    window.Swal = require('sweetalert2');
    window.toastr = require('toastr');
    window.moment = require('moment');
    window.Ladda = require('ladda');
    window.PDFObject = require('pdfobject');
    window.c3 = require('c3');
    window.collect = require('collect.js');
    screenfull = require('screenfull');

    window.pdfMake = require('pdfmake/build/pdfmake.js');
    window.pdfFonts = require('./pdfmake/vfs_fonts.js');
    window.pdfMake.vfs = window.pdfFonts.pdfMake.vfs;
    window.pdfMake.fonts = {
        "Arabic+Bangla": {
            normal: 'Arabic+Bangla.ttf',
            bold: 'Arabic+Bangla.ttf',
            italics: 'Arabic+Bangla.ttf',
            bolditalics: 'Arabic+Bangla.ttf'
        }
    };

    window.jspdf = require('jspdf');
    window.JSZip = require('jszip');
    window.editor = require('./editor.js');

    const {
        browserSupportsWebAuthn,
        startAuthentication,
        startRegistration,
    } = require('@simplewebauthn/browser');

    window.browserSupportsWebAuthn = browserSupportsWebAuthn;
    window.startAuthentication = startAuthentication;
    window.startRegistration = startRegistration;

    require('bootstrap');
    require('bootstrap-datepicker');
    require('bootstrap-select');
    require('patternfly-bootstrap-treeview');
    require('breakpoints-js');
    require('datatables.net');
    require('datatables.net-bs4');
    require('datatables.net-buttons');
    require('datatables.net-buttons/js/buttons.colVis');
    require('datatables.net-buttons/js/buttons.html5');
    require('datatables.net-buttons/js/buttons.print');
    require('datatables.net-buttons-bs4');
    require('datatables.net-fixedheader');
    require('datatables.net-fixedheader-bs4');
    require('datatables.net-rowreorder');
    require('datatables.net-rowreorder-bs4');
    require('datatables.net-colreorder');
    require('datatables.net-colreorder-bs4');
    require('datatables.net-select');
    require('datatables.net-select-bs4');
    require('dropify');
    require('fabric');
    require('floatthead');
    require('fullcalendar');
    require('fullcalendar/dist/locale/ar');
    require('./fullcalendar/locale/bn');
    require('intro.js');
    require('jquery-asHoverScroll');
    require('jquery-asScrollable');
    require('jquery-asScrollbar');
    require('jquery-inview');
    require('jquery-match-height');
    require('jquery-placeholder');
    require('jquery-serializejson');
    require('jquery-slidePanel');
    require('jquery.mousewheel');
    require('masonry-layout/dist/masonry.pkgd');
    require('nestable2');
    require('summernote');
    require('switchery-npm');
    require('timepicker');
    require('corejs-typeahead/dist/typeahead.bundle');

    window.ace = require('ace-builds/src-noconflict/ace');
    require('ace-builds/src-noconflict/mode-html');
    require('ace-builds/src-noconflict/mode-css');
    require('ace-builds/src-noconflict/theme-github_light_default');

    Breakpoints();
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
